/* eslint-disable no-restricted-syntax */
import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'
import _map from 'lodash/map'

export enum OrderStatusEnum {
  待付款 = 1,
  已付款等待币商确认 = 2,
  已放币交易完成 = 3,
  用户已取消 = 4,
  超时取消 = 5,
  后台取消 = 6,
  后台放币 = 7,
  币商取消 = 8,
}

export const merchant_detail = createAsyncThunk(
  'Saada/BuyCoinSaada/merchant_detail',
  async (p: any, store: any) => {
    const resp = await http.post('/live/merchant/merchant_detail', p, {
      store,
      xcErrorToast: true,
    })
    return resp.data.data?.merchant || {}
  }
)

export const get_order_detail = createAsyncThunk(
  'Saada/BuyCoinSaada/get_order_detail',
  async (p: any, store: any) => {
    const resp = await http.post('/live/merchant/get_order_detail', p, {
      store,
      xcErrorToast: true,
    })
    return resp.data.data?.order || {}
  }
)

export const get_coin_packages = createAsyncThunk(
  'Saada/BuyCoinSaada/get_coin_packages',
  async (p: any, store: any) => {
    const resp = await http.post('/live/merchant/get_coin_packages', p, {
      store,
      xcErrorToast: true,
    })
    return resp.data.data
  }
)

export const create_order = createAsyncThunk(
  'Saada/BuyCoinSaada/create_order',
  async (p: any, store: any) => {
    const resp = await http.post('/live/merchant/create_order', p, {
      store,
      xcErrorToast: true,
    })
    return resp.data.data
  }
)

export const confirm_payment = createAsyncThunk(
  'Saada/BuyCoinSaada/confirm_payment',
  async (p: any, store: any) => {
    const resp = await http.post('/live/merchant/confirm_payment', p, {
      store,
      xcErrorToast: true,
    })
    return resp.data.data
  }
)

export const confirm_release = createAsyncThunk(
  'Saada/BuyCoinSaada/confirm_release',
  async (p: any, store: any) => {
    const resp = await http.post('/live/merchant/confirm_release', p, {
      store,
      xcErrorToast: true,
    })
    return resp.data.data
  }
)

export const dispute_order = createAsyncThunk(
  'Saada/BuyCoinSaada/dispute_order',
  async (p: any, store: any) => {
    const resp = await http.post('/live/merchant/dispute_order', p, {
      store,
      xcErrorToast: true,
    })
    return resp.data.data
  }
)
export const base_config = createAsyncThunk(
  'Saada/BuyCoinSaada/base_config',
  async (p: any, store: any) => {
    const resp = await http.post('/live/merchant/base_config', p, {
      store,
      xcErrorToast: true,
    })
    return resp.data.data?.cancel_order_reasons || []
  }
)
export const merchant_list = createAsyncThunk(
  'Saada/BuyCoinSaada/merchant_list',
  async (p: any, store: any) => {
    const resp = await http.post(
      '/live/merchant/merchant_list',
      {offset: 0, page_size: 1},
      {
        store,
        xcErrorToast: true,
      }
    )
    return resp.data.data?.channels || []
  }
)

export interface InitialStateType {
  showGuide?: boolean
  orderDetail?: any
  merchantDetail?: any
  coinPackageInfo?: any
  defaultChannelIds?: Array<string>
  cancel_order_reasons?: Array<any>
}

const initialState: InitialStateType = {}
const initData: InitialStateType = {
  showGuide: false,
  orderDetail: {},
  merchantDetail: {},
  coinPackageInfo: {},
  defaultChannelIds: [],
  cancel_order_reasons: [],
}

export const SaadaBuyCoinSlice = createSlice({
  name: 'Animal_Magpie',
  initialState,
  reducers: {
    initData: (state) => {
      Object.assign(state, initData)
    },
    setShowGuide: (state, action) => {
      Object.assign(state, {
        showGuide: action.payload,
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase(merchant_detail.fulfilled, (state, action) => {
      Object.assign(state.merchantDetail, action.payload)
    })
    builder.addCase(get_order_detail.fulfilled, (state, action) => {
      Object.assign(state.orderDetail, action.payload)
    })
    builder.addCase(get_coin_packages.fulfilled, (state, action) => {
      Object.assign(state.coinPackageInfo, action.payload)
    })
    builder.addCase(base_config.fulfilled, (state, action) => {
      Object.assign(state.cancel_order_reasons, action.payload)
    })
    builder.addCase(merchant_list.fulfilled, (state, action) => {
      Object.assign(state, {
        defaultChannelIds: _map(action.payload, (it) => it.channel),
      })
    })
  },
})
export default SaadaBuyCoinSlice.reducer
export const SaadaBuyCoinActions = SaadaBuyCoinSlice.actions

export const useSaadaBuyCoinState = () => {
  const data = useSelector((state) => {
    return state.Animal_Magpie
  })
  return data
}
